(function () {
  'use strict'

  require('./scss/cart-card.scss')
  require('dynamic-bind-html')

  const MODULE_NAME = 'thismoment.glow.component.glow-cart.component.cart-card'
  const templateUrl = require('./tpl/cart-card.html')
  const defaultImage = require('../../../../../common/assets/img/placeholder.png')

  angular
    .module(MODULE_NAME, [
      'dynamicBindHtml'
    ])
    .component('thismomentGlowCartCard', {
      templateUrl: templateUrl,
      bindings: {
        item: '<',
        isEdit: '<',
        isRemove: '<',
        removeItem: '&'
      },
      controller: cartCardController
    })

  cartCardController.$inject = ['$rootScope', '$timeout', '$scope', 'Cart']
  function cartCardController ($rootScope, $timeout, $scope, Cart) {
    const vm = this
    vm.$onInit = cartInit

    function cartInit () {
      vm.defaultImage = defaultImage
      vm.showPreviewImage = vm.item.class_name !== 'text'
      vm.formatted = {}
      vm.formatted.textOnly = vm.item.title || vm.item.description_ptf
      vm.formatted.imageSrc = vm.item.images.large.url
      vm.formatted.text = vm.item.title || vm.item.description_ptf || '&nbsp;'
      vm.formatted.text = vm.formatted.text.replace(/[\n\r]/g, ' ').substring(0, 30)
      vm.removeClick = removeClick
      vm.isTrashClicked = false
      determineOrder()

      function determineOrder () {
        vm.orderId = Cart.getItemPosition(vm.item.id) + 1
      }

      function removeClick () {
        if (vm.isTrashClicked) {
          vm.removeItem({id: vm.item.id})
        } else {
          vm.isTrashClicked = true
          $timeout(() => {
            vm.isTrashClicked = false
          }, 3000)
        }
      }

      $rootScope.$on('cart:reorder', () => {
        determineOrder()
        $timeout(() => {
          $scope.$apply()
        })
      })
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-cart/component/cart-card/index.js